import FormControl from '@mui/joy/FormControl';
import Radio, { radioClasses } from '@mui/joy/Radio';
import RadioGroup from '@mui/joy/RadioGroup';
import { useTheme } from '@mui/joy';
import { ChangeEvent } from 'react';
import { SimpleOption } from '../../types';
import { useMediaQuery } from '../../hooks';

interface Props {
	values?: string[];
	onChange?: (values: string[]) => void;
	options: SimpleOption[];
	print?: boolean;
	page?: string;
}
export default function RadioButtons({
	options = [],
	values = [],
	onChange = (values) => console.log(values),
	print,
	page
}: Props) {
	//const [localValues, setLocalValues] = useState<string[]>(values);
	const theme = useTheme();
	const isDonorNational = page === 'donorNational';
	function handleOnChange(
		event: ChangeEvent<HTMLInputElement> | null,
		id: string
	) {
		if (event?.target) {
			const { checked } = event.target;
			const nVals = checked ? [id] : [];

			//	setLocalValues(nVals);
			onChange(nVals);
		}
	}

	// useEffect(() => {
	// 	if (values.some((val, index) => val !== localValues[index])) {
	// 		setLocalValues(values);
	// 	}
	// 	// eslint-disable-next-line react-hooks/exhaustive-deps
	// }, [values]);
	const matches = useMediaQuery(theme.breakpoints.up('md'));

	return (
		<div>
			<FormControl sx={{ marginBottom: print ? '1rem' : 0 }}>
				<RadioGroup
					size='sm'
					defaultValue='outlined'
					orientation={
						isDonorNational ? 'vertical' : matches ? 'horizontal' : 'vertical'
					}
					sx={{
						margin: {
							xs: '.5rem 1rem .5rem 0'
							//md: isDonorNational ? '1rem 1rem .5rem 0' : '.5rem 1rem .5rem 0'
						}
					}}
				>
					{options.map(({ label, id }) => (
						<Radio
							key={id}
							label={label}
							onChange={(e) => handleOnChange(e, id)}
							checked={values.includes(id)}
							slotProps={{
								label: {
									sx: {
										fontFamily: 'Source Sans Pro, sans-serif',
										fontSize: '16px',
										lineHeight: print ? 0 : 'unset'
									}
								}
							}}
							sx={{
								marginBottom: {
									xs: '.5rem',
									md: isDonorNational ? '.5rem' : 0
								},
								[`& .${radioClasses.checked}`]: {
									'--variant-borderWidth': '8px',
									borderColor:
										theme.colorSchemes.light.palette.controls.controlFill
								}
							}}
						/>
					))}
				</RadioGroup>
			</FormControl>
		</div>
	);
}
